import { Alert, Card, Heading, Link, Pane, Paragraph, Spinner, Strong, Text } from 'evergreen-ui';
import { useEffect, useState } from 'react';
import Api from '../../../util/Api';

const CredentialRow = ({ label, value }) => (
    <Pane display="flex" alignItems="center" marginBottom={4}>
        <Text color="muted" width={160}>{label}:</Text>
        <Strong>{value}</Strong>
    </Pane>
);

const PlatformAccess = () => {
    const [platforms, setPlatforms] = useState([]);
    const [stores, setStores] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await Api.get('/platform-access');
                setPlatforms(response.platforms || []);
                setStores(response.stores || []);
            } catch (err) {
                setError('Failed to load platform access data. You may not have permission.');
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    if (loading) {
        return (
            <Pane display="flex" alignItems="center" justifyContent="center" height={200}>
                <Spinner />
            </Pane>
        );
    }

    if (error) {
        return <Alert intent="danger" title="Error" marginBottom={20}>{error}</Alert>;
    }

    return (
        <Pane>
            <Alert intent="warning" title="Confidential" marginBottom={20}>
                This information is restricted to managers and administrators. Do not share these credentials.
            </Alert>

            <Heading size={500} marginBottom={16}>Platform Links &amp; Credentials</Heading>
            <Pane display="flex" flexWrap="wrap" gap={16} marginBottom={32}>
                {platforms.map((platform) => (
                    <Card
                        key={platform.name}
                        elevation={1}
                        padding={20}
                        minWidth={300}
                        flex="1"
                        background="white"
                        border="default"
                    >
                        <Heading size={400} marginBottom={8}>{platform.name}</Heading>
                        <Paragraph marginBottom={platform.credentials.length > 0 ? 12 : 0}>
                            <Link href={platform.url} target="_blank" rel="noopener noreferrer">
                                {platform.url}
                            </Link>
                        </Paragraph>
                        {platform.credentials.map((cred) => (
                            <CredentialRow key={cred.label} label={cred.label} value={cred.value} />
                        ))}
                    </Card>
                ))}
            </Pane>

            <Heading size={500} marginBottom={16}>Store Accounts</Heading>
            <Pane display="flex" flexWrap="wrap" gap={16}>
                {stores.map((store) => (
                    <Card
                        key={store.name}
                        elevation={1}
                        padding={20}
                        minWidth={300}
                        flex="1"
                        background="white"
                        border="default"
                    >
                        <Heading size={400} marginBottom={12}>{store.name}</Heading>
                        {store.details.map((detail) => (
                            <CredentialRow key={detail.label} label={detail.label} value={detail.value} />
                        ))}
                    </Card>
                ))}
            </Pane>
        </Pane>
    );
};

export default PlatformAccess;
